import { Box, Heading, Text } from '@bechtel/gds';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import { css } from 'styled-components';
import { ReactComponent as UnderConstructionIcon } from '../../images/under-construction.svg';
import { UnderConstructionStyled } from './styled';

export const UnderConstruction = () => {
  return (
    <Box
      flexDirection={{ sm: 'column' }}
      justifyContent={{ sm: 'center' }}
      alignItems={{ sm: 'center' }}
      css="height: 100%;"
    >
      <UnderConstructionStyled>
        <UnderConstructionIcon
          css={`
            ${({ theme }) =>
              css`
                fill: ${theme.colors.blue[300]};
              `}
          `}
        />
      </UnderConstructionStyled>
      <Box mt={{ sm: '400' }} mb={{ sm: '500' }}>
        <Heading family="graphik" size="800" color="grey.600" weight="600">
          Under Construction
        </Heading>
      </Box>
      <Text family="graphik" size="600" color="grey.600">
        We’re currently working on this page. Thanks for your patience!
      </Text>
    </Box>
  );
};
